/* eslint-disable import/no-cycle */

import Const from '../const';
import {
  screenNames, routes, generalPaths
} from '../../components/routes/routes_const';
import { getWebOrderInfoAPI } from '../../utils/api';
import { setErrorAction, errorTypes } from '../application/application_action';
import { routeMatch } from '../../utils/util';

const selectScreenName = () => {
  const generalRoutes = Object.keys(generalPaths)
    .map((key) => generalPaths[key]);
  const match = routeMatch(generalRoutes);
  if (Object.keys(match).length > 0) {
    const generalPathsKey = Object.keys(generalPaths)
      .find((key) => generalPaths[key] === match.path);
    return routes[generalPathsKey];
  }
  return null;
};

const initialScreenName = () => selectScreenName();

export const updateCurrentScreen = (screenName) => (dispatch) => {
  const screen = routes[screenNames[screenName]];
  dispatch({
    type: Const.navigation.updateCurrentScreen,
    currentScreen: screen
  });
};

const updateInitalScreen = (initialScreen) => ({
  type: Const.navigation.initialScreen,
  initialScreen
});

export const setupInitialScreen = () => (dispatch) => {
  getWebOrderInfoAPI().then((webOrderInfo) => {
    const initialScreen = initialScreenName(webOrderInfo);
    dispatch(updateInitalScreen(initialScreen));
  }).catch((error) => { dispatch(setErrorAction({ [errorTypes.error]:  error })); });
};

export const updateBackButton = (backAction) => ({
  type: Const.navigation.backAction,
  backAction
});
